//$('#top-img').find("img").attr("src", $('#top-img').find("img").attr("src").replace("large", "1024x1024"));



$(document).ready(function() {

  


  $('#mathhater').click(function(){
    alert("It hates you too.")
  });
  
  //Replace Top-Post Image with a larger version
  			
  //Show Old Comments Section
$('#show-old').click(function(){

          
          $('#old-comments').slideToggle(); 
          if ($('#old-comments').is(":visible")){
            $('#show-old').text('Hide Old Comments')
          }
            else{
              $('#show-old').text('Show Old Comments')
            }
  //preventDefault()
});


  //Wrap IMGs in FancyBox Links
  
  
$("#article img").each(function() {
  //  $(this).find("li").find("a").attr("rel","gallery"+(index+1));
  //alert(this.src);
  
  if (this.alt.indexOf("link") < 0){
    var imgurl = this.src;

    var caption = this.alt;
    if (imgurl.indexOf("cdn.shopify") >= 0)
    {
      if (imgurl.indexOf("grande") >= 0)
      imgurl = imgurl.replace(/\grande/g, '1024x1024');

      if (imgurl.indexOf("large") >= 0)
      imgurl = imgurl.replace(/\large/g, '1024x1024');

      if (imgurl.indexOf("medium") >= 0)
      imgurl = imgurl.replace(/\medium/g, '1024x1024');
    }

    if (imgurl.indexOf("shopify") >= 0)
    $( this ).wrap( "<a id='single_image' rel='gallery' title='" + caption + "' href='" + imgurl + "'></a>" );
  }
});
  
  
  
  
//slide out share box last paragraph

$(function() {
	$(window).scroll(function(){
		var distanceTop = $('#last').offset().top - $(window).height();

		if  ($(window).scrollTop() > distanceTop)
			$('#slidebox').animate({'right':'0px'},300);
		else
			$('#slidebox').stop(true).animate({'right':'-430px'},100);
	});

	$('#slidebox .close').bind('click',function(){
		$(this).parent().remove();
	});
});

  
  
  
});